import { Stack, StackProps, useTheme } from "@mui/material";

import { DashboardSkeleton } from "@/components/dashboard-design-system/Skeleton";
import { mergeSx } from "@/helpers/mergeSx";

type DashboardSelectBarSkeletonProps = {
  sx?: StackProps["sx"];
};

export const DashboardSelectBarSkeleton = ({ sx }: DashboardSelectBarSkeletonProps) => {
  const theme = useTheme();

  const styles = mergeSx(
    {
      padding: { xs: theme.spacing(1.5, 3), md: theme.spacing(2, 3) },
      border: `1px solid ${theme.palette.border.neutral.quiet}`,
      borderRadius: theme.spacing(1),
      boxSizing: "border-box",
    },
    sx
  );

  return (
    <Stack sx={styles}>
      <DashboardSkeleton width="120px" fontSize="subtitle1" />
      <DashboardSkeleton width="80%" fontSize="body2" />
      <DashboardSkeleton width="60%" fontSize="body2" />
    </Stack>
  );
};
